import {
    URLAPI,
    WORK_ACTIVITIES_PATH,
    WORK_ACTIVITY_CREATE_PATH,
    WORK_ACTIVITY_TEAM_CREATE_PATH,
    WORK_ACTIVITY_UPDATE_PATH,
    WORK_ACTIVITY_TEAM_DELETE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_work_activities: {
        data: [],
        status: 0,
        message: {},
    },
    _create_work_activity: {
        data: {},
        status: 0,
        message: {},
    },
    _update_work_activity: {
        data: {},
        status: 0,
        message: {},
    },
    _create_work_activity_team: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_work_activity_team: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_WORK_ACTIVITIES = "GET_ALL_WORK_ACTIVITIES";
export const CREATE_WORK_ACTIVITY = "CREATE_WORK_ACTIVITY";
export const CREATE_WORK_ACTIVITY_TEAM = "CREATE_WORK_ACTIVITY_TEAM";
export const UPDATE_WORK_ACTIVITY = "UPDATE_WORK_ACTIVITY";
export const DELETE_WORK_ACTIVITY_TEAM = "DELETE_WORK_ACTIVITY_TEAM";

export const work_activities_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_WORK_ACTIVITIES:
            return {
                ...state,
                _get_all_work_activities: action.payload,
            };
        case CREATE_WORK_ACTIVITY:
            return {
                ...state,
                _create_work_activity: action.payload,
            };
        case CREATE_WORK_ACTIVITY_TEAM:
            return {
                ...state,
                _create_work_activity_team: action.payload,
            };
        case UPDATE_WORK_ACTIVITY:
            return {
                ...state,
                _update_work_activity: action.payload,
            };
        case DELETE_WORK_ACTIVITY_TEAM:
            return {
                ...state,
                _delete_work_activity_team: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllWorkActivities = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${WORK_ACTIVITIES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_WORK_ACTIVITIES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_WORK_ACTIVITIES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_WORK_ACTIVITIES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createWorkActivity = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_ACTIVITY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateWorkActivity = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${WORK_ACTIVITY_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_WORK_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_WORK_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_WORK_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const searchWorkActivity = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${WORK_ACTIVITIES_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const createWorkActivityTeam = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            if (key !== 'equipos') {
                form.append(key, data[key]);
            } else {
                form.append(key, JSON.stringify(data[key]));
            }
        }
        const response = await axios.post(
            `${URLAPI}${WORK_ACTIVITY_TEAM_CREATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_ACTIVITY_TEAM,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_ACTIVITY_TEAM,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_ACTIVITY_TEAM,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteWorkActivityTeam = (token, id_team, id_work_activity) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${WORK_ACTIVITY_TEAM_DELETE_PATH}${id_team}/${id_work_activity}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_WORK_ACTIVITY_TEAM,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_WORK_ACTIVITY_TEAM,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_WORK_ACTIVITY_TEAM,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const clear_work_activity = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
